import React from "react";
import {
    NewStyledBankCardsWrapper,
    NewStyledPrecalculationFormCardWrapper,
    StyledBankCardHeader, StyledBankLogo, StyledDeclarationFormCard,
    StyledPrecalculationForm,
    StyledPrecalculationFormCard,
    StyledPrecalculationFormWrapper, StyledText4Oms
} from "../precalculation/ui/styles";
import {Heading2, Text4} from "../../../libs/uiKit/globalStyledComponents";
import Button from "../../../libs/uiKit/button";
import {DownloadIcon} from "../../../icons/ui/Download";
import {Heading21, Heading4, Text1, Text2} from "../../../libs/uiKit/globalStyles";
import {FieldsBuilder} from "../../../libs/uiKit/fieldsBuilder";
import HouseReady from "../precalculation/ui/HouseReady";
import Result from "../precalculation/ui/Result";
import MainLayoutIgniter from "../common/mainLayout";
import {QueriesCreateAgreement} from "../createAgreement/ds/repositories/queries";
import {useGlobalContext} from "../../../apps/main/ui/GlobalContext";
import {
    AgreementSteps, CommandsCreateAgreement,
    formatAgreementDataToFormData,
    setDataToForm
} from "../createAgreement/ds/repositories/commands";
import {AgreementId, CreateAgreementForm} from "../createAgreement/ui/context";
import {useNavigate, useParams} from "react-router-dom";
import useNotification from "../../widgets/notifier/ui/hooks/useNitification";
import {FormProvider, useForm} from "react-hook-form";
import RedHint from "../../../libs/uiKit/hint/RedHint";
import CollapsibleTable from "../precalculation/ui/CollapsibleTable";
import {stringToMoney, stringToNumber} from "../../../libs/uiKit/utils";
import Input from "../../../libs/uiKit/input";
import {
    StyledCircle,
    StyledRadioBox,
    StyledRadioInput,
    StyledRadioItemsWrapper,
    StyledRadioWrapper
} from "../../../libs/uiKit/radio/styles";
import {PrecalculationForm} from "../precalculation/ui/context";
import DeclarationTextModal from "../precalculation/ui/DeclarationTextModal";
import ResultItem from "../precalculation/ui/ResultItem";
import {IForm} from "../../../libs/uiKit/fieldsBuilder/types";
import {
    PRODUCT_FLAT,
    PRODUCT_MORTGAGE, PROPERTY_APARTMENTS, PROPERTY_FLAT, PROPERTY_TOWNHOUSE,
    RADIO_BOOLEAN, RADIO_PERIOD_TYPE,
    RADIO_SEX,
    RUSSIA_COUNTRY_ISN
} from "../../../libs/utils/staticData";
import dayjs from "dayjs";
import {getSelectDefaultValue} from "../../../libs/utils/getSelectdefaultValue";
import Contragent from "./Contragent";
import {useMutation} from "@apollo/client";
import {
    CalculateAgreementFinishMutation, CalculateAgreementFinishMutationVariables,
    CalculateAgreementMutation,
    CalculateAgreementMutationVariables, DictKeyEnum
} from "../../../libs/api/graphqlTypes";
import {CALC_AGREEMENT, CALCULATE_AGREEMENT_FINISH} from "../../../libs/api/commands";
import {useUserRights} from "../common/hooks/useUserRights";
import {ISelectItem} from "../../../libs/uiKit/select/types";
import useGetDicti from "../common/hooks/useGetDicti";
import {StyledShareBadge} from "./styles";


export type DeclarationForm = {
    isInsurer?: boolean;
    isRegistrationAddress?: boolean;
    isResidenceAddress?: boolean;
}
const DeclarationPage: React.FC = () => {

    const {
        api,
        routes: { contractById, agreementByIdUnderwriter, agreementByIdSeller },
    } = useGlobalContext();
    const { setNotification } = useNotification();
    const navigate = useNavigate();
    const { rightsHandler } = useUserRights();

    const { id } = useParams<{ id?: string }>();
    const agreementId: AgreementId = Number.isNaN(Number(id)) ? null : Number(id);

    const queriesCreateAgreements = React.useMemo(() => QueriesCreateAgreement(api), [api]);
    const commandsCreateAgreements = React.useMemo(() => CommandsCreateAgreement(api, queriesCreateAgreements), [api, queriesCreateAgreements]);

    const [calcAgreement, { loading: loadingCalcAgreement }] = useMutation<CalculateAgreementMutation, CalculateAgreementMutationVariables>(CALC_AGREEMENT);
    const [calcAgreementFinish, { loading: loadingCalcAgreementFinish }] = useMutation<CalculateAgreementFinishMutation, CalculateAgreementFinishMutationVariables>(CALCULATE_AGREEMENT_FINISH);

    const { data: selectOrganization, loading: loadingOrganization } = useGetDicti(DictKeyEnum.CreditBank);
    const { data: prevSkList, loading: loadingPrevSkList } = useGetDicti(DictKeyEnum.PrevSk);
    const { data: renewReasons, loading: loadingRenewReasons } = useGetDicti(DictKeyEnum.RenewReasons);

    const [statePrecalcResult, setStatePrecalcResult] = React.useState<any>(null);
    const [stateCalcForm, setStateCalcForm] = React.useState<any>(null);
    const [stateIsLoading, setIsLoading] = React.useState<boolean>(false);
    const [stateAddressEgrn, setAddressEgrn] = React.useState<boolean>(false);

    const formHook = useForm<CreateAgreementForm>({
        mode: 'onBlur',
    });

    // @ts-ignore
    const [isInsurer, isRegistrationAddress, isResidenceAddress, creditTerms, isSameAddress, dateBegin, dateExactEnd, renewReason] = formHook.watch(['isInsurer', 'properties[0].isRegistrationAddress', 'properties[0].isResidenceAddress', 'creditTerms', 'contragents[1].addressRadio', 'dateBegin', 'dateExactEnd', 'renewReason']);

    const insuranceType = stateCalcForm?.credit?.insuranceType || 0;

    const riskLife = !!stateCalcForm?.riskLife;
    const riskProperty = !!stateCalcForm?.riskProperty;
    const bankIsn = stateCalcForm?.credit?.bank?.value;

    const coBorrowersAny = stateCalcForm?.coBorrowers;
    const coBorrowers: any[] = Array.isArray(coBorrowersAny) ? coBorrowersAny : [];
    const haveCoBorrowers = coBorrowers.length > 0;
    const borrower = stateCalcForm?.borrower;

    const propertyName = stateCalcForm?.propertyObjects?.[0]?.propertyPledge?.label || "Квартира";

    const pledgeIsn = stateCalcForm?.propertyObjects?.[0]?.propertyPledge?.value || PROPERTY_FLAT;

    const creditIssueDate = stateCalcForm?.credit?.creditIssueDate;

    const isAnnual = selectOrganization.find((item: ISelectItem) => item.value === bankIsn)?.extra?.annual || false;
    const reqCadNumber = selectOrganization.find((item: ISelectItem) => item.value === bankIsn)?.extra?.cad_number || false;

    const isShowRenewReasonOther = renewReason?.value === '5';

    const dateEnd = creditTerms && dateBegin
        ? dayjs(dateBegin).add(creditTerms, 'month').subtract(1, 'day')
        : (dateExactEnd ? dayjs(dateExactEnd) : null);

    const refreshFormDataHandler = () => {
        if (!agreementId) return setNotification({ type: 'error', text: 'no id' });
        queriesCreateAgreements
            .getAgreementById(agreementId, true)
            .then(({ data }) => {
                if (!data) return setNotification({ type: 'error', text: 'no agreement data' });
                const formData = formatAgreementDataToFormData(data);
                setDataToForm(formData, formHook, data.loadAgreement?.product || 1);
                setTimeout(() => setDataToForm(formData, formHook, data.loadAgreement?.product || 1), 1);
                setStateCalcForm(data?.loadAgreement?.calcForm);
                console.log('calc form loaded', data?.loadAgreement?.calcForm);
                setStatePrecalcResult(data?.loadAgreement?.calcForm?.precalcResult);
            })
            .catch(error => setNotification({ type: 'error', text: error }));
    }

    const getRedirectUrlByIsn = (agrIsn: number) =>
        agrIsn > 0 ?
            contractById(String(agrIsn))
            : (rightsHandler('underwritingPage') ? agreementByIdUnderwriter(String(agrIsn)) : agreementByIdSeller(String(agrIsn)))

    const coborrowerCaption = (index: number): string => {
        if(coBorrowers?.length === 1) return 'Созаемщик';
        switch (index) {
            case 0:
                return 'Первый созаёмщик';
            case 1:
                return 'Второй созаёмщик';
            case 2:
                return 'Третий созаёмщик';
            case 3:
                return 'Четвёртый созаёмщик';
            case 4:
                return 'Пятый созаёмщик';
            case 5:
                return 'Шестой созаёмщик';
            default:
                return `Созаемщик №${index + 1}`;
        }
    }

    const backToPrecalc = () => {
        if (!agreementId) return setNotification({ type: 'error', text: 'no id' });

        const formData = formHook.getValues() as CreateAgreementForm;

        setIsLoading(true);

        commandsCreateAgreements.saveAgreement({
            id: agreementId,
            currentFormData: formData,
            step: 'precalculation',
            successCallback: () => {
                setIsLoading(false);
                navigate(`/precalculation/${agreementId}`);
            },
            errorCallback: error => {
                setIsLoading(false);
                setNotification({ type: 'error', text: error });
            },
        });
    }

    const onFormSubmit = formHook.handleSubmit(formData => {
        if (!agreementId) return setNotification({ type: 'error', text: 'no id' });
        setIsLoading(true);
        formData.contragents[1].share = borrower?.share;
        coBorrowers.forEach((item, index) => {
            if(formData.coBorrowers && formData.coBorrowers[index]){
                formData.coBorrowers[index].share = item.share
            }
        });
        commandsCreateAgreements.saveAgreement({
            id: agreementId,
            currentFormData: formData,
            step: 'contragentStep',
            successCallback: () => {
                console.info('Calculate...')
                calcAgreement({
                    variables: {
                        id: agreementId,
                    },
                })
                    .then((data) => {
                        calcAgreementFinish({
                            variables: {
                                id: agreementId,
                            },
                        })
                            .then((data) => {
                                setIsLoading(false);
                                const agrIsn = data.data?.calculateAgreementFinish;
                                if(agrIsn && agrIsn > 0){
                                    console.info('Create agreement', agrIsn);
                                }
                                setNotification({ type: 'success', text: (agrIsn && agrIsn > 0) ? 'Договор успешно создан' : 'Заявка успешно создана' });

                                const nextUrl = contractById(String(agrIsn));

                                navigate(nextUrl);
                            })
                            .catch(error => {
                                setIsLoading(false);
                                setNotification({type: 'error', text: error});
                            });
                    })
                    .catch(error => {
                        setIsLoading(false);
                        setNotification({type: 'error', text: error});
                    });
            },
            errorCallback: error => {
                setIsLoading(false);
                setNotification({ type: 'error', text: error });
            },
        });
    });

    React.useEffect(() => {
        refreshFormDataHandler();
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth',
        });

    }, [agreementId]);

    React.useEffect(() => {
        if (!isAnnual) return;
        formHook.setValue('creditTerms', 12);
    }, [isAnnual]);

    const isInsurerForm: IForm = React.useMemo(
        () => ({
            formHook,
            fields: [
                {
                    field: {
                        fieldType: 'checkbox',
                        fieldName: 'isInsurer',
                        label: 'Является страхователем',
                    },
                },
            ],
        }),
        [formHook]
    );

    const flatForm: IForm = React.useMemo(
        () => ({
            formHook,
            fields: [
                {
                    field: {
                        fieldType: 'checkbox',
                        fieldName: 'properties[0].isRegistrationAddress',
                        label: 'По адресу регистрации заёмщика',
                        isDisabled: isResidenceAddress,
                        width: "28rem"
                    },
                },
                {
                    field: {
                        fieldType: 'checkbox',
                        fieldName: 'properties[0].isResidenceAddress',
                        label: 'По адресу проживания заёмщика',
                        isDisabled: isRegistrationAddress || isSameAddress,
                        width: "28rem"
                    },
                },
                {
                    isHidden: isRegistrationAddress || isResidenceAddress,
                    field: {
                        fieldType: 'daData',
                        fieldName: `properties[0].pledgeAddress`,
                        daDataType: 'address',
                        placeholder: 'Адрес расположения',
                        isRequired: true,
                        errorMessage: 'Введите адрес',
                    },
                },
                {
                    field: {
                        fieldType: 'input',
                        fieldName: `properties[0].cadastralNumber`,
                        label: 'Кадастровый номер',
                        placeholder: 'Введите кадастровый номер',
                        grid: 6,
                        isRequired: ![PROPERTY_FLAT, PROPERTY_APARTMENTS, PROPERTY_TOWNHOUSE].includes(String(pledgeIsn)) || reqCadNumber,
                    },
                },
                {
                    field: {
                        fieldType: 'element',
                        fieldName: `properties[0].showIsErgn`,
                        element: (
                            <Button appearance='link' onClick={(): void => setAddressEgrn(state => !state)}>
                                Ввести адрес как в ЕГРН
                            </Button>
                        ),
                    },
                },
                {
                    isHidden: !stateAddressEgrn,
                    field: {
                        fieldType: 'input',
                        fieldName: `properties[0].pledgeAddressEgrn`,
                        placeholder: 'Ввод адреса из ЕГРН',
                    },
                },

            ],
        }),
        [formHook, isRegistrationAddress, isResidenceAddress, isSameAddress, stateAddressEgrn]
    );

    const creditForm: IForm = React.useMemo(
        () => ({
            formHook,
            fields: [
                {
                    field: {
                        fieldType: 'number',
                        fieldName: 'summ',
                        isDisabled: true,
                        grid: 6,
                        digitsAfterDot: 2,
                        errorMessage: 'Введите размер кредита',
                        placeholder: 'Размер кредита, ₽',
                        validationType: 'minMax',
                        maxValue: 1000000000,
                    },
                },
                {
                    field: {
                        fieldType: 'number',
                        fieldName: 'creditRate',
                        digitsAfterDot: 2,
                        isDisabled: true,
                        errorMessage: 'Введите ставку',
                        placeholder: 'Процентная ставка, %',
                        validationType: 'minMax',
                        maxValue: 100,
                        grid: 6,
                    },
                },
                {
                    field: {
                        fieldType: 'daData',
                        daDataType: 'address',
                        fieldName: 'dealCountry',
                        placeholder: 'Населённый пункт сделки',
                        validationType: 'addressWithCity',
                        isDisabled: true,
                        grid: 6,
                    },
                },
                {
                    field: {
                        fieldType: 'date',
                        fieldName: 'creditIssueDate',
                        errorMessage: 'Выберите дату',
                        placeholder: 'Дата кредитного договора',
                        isDisabled: true,
                        grid: 6,
                    },
                },
                {
                    isHidden: isAnnual,
                    field: {
                        fieldType: 'date',
                        fieldName: 'creditIssueDate2',
                        placeholder: 'Дата выдачи кредита',
                        grid: 6,
                        validationType: 'minMaxDate',
                        minDate: creditIssueDate ? dayjs(creditIssueDate, 'DD.MM.YYYY').toDate() : undefined
                    },
                },
                {
                    //isHidden: ![1, 3].includes(insuranceType) && !isAnnual,
                    field: {
                        fieldType: 'number',
                        fieldName: 'creditTerms',
                        isRequired: true,
                        isDisabled: isAnnual,
                        validationType: 'minMax',
                        minValue: 12,
                        maxValue: 362,
                        errorMessage: 'Введите срок кредитования',
                        placeholder: 'Срок кредитования, мес',
                        grid: 6,
                    },
                },
                /*{
                    isHidden: ![2, 4, 5].includes(insuranceType) || isAnnual,
                    field: {
                        fieldType: 'date',
                        fieldName: 'dateExactEnd',
                        placeholder: 'Дата окончания кредитного договора',
                        grid: 6,
                        validationType: 'minMaxDate',
                        minDate: dayjs().toDate()
                    },
                },*/
                {
                    field: {
                        fieldType: 'input',
                        fieldName: 'creditAgreementNumber',
                        placeholder: 'Номер договора',
                        isRequired: true,
                        grid: 6,
                    },
                },
                {
                    isHidden: ![4].includes(insuranceType),
                    field: {
                        fieldType: 'select',
                        fieldName: 'prevSk',
                        isLoading: loadingPrevSkList,
                        placeholder: 'Предыдущая страховая компания',
                        items: prevSkList,
                        isSearchAvailable: true,
                        isClearable: true,
                        grid: 6,
                    },
                },
                {
                    isHidden: ![5].includes(insuranceType),
                    field: {
                        fieldType: 'select',
                        fieldName: 'renewReason',
                        isLoading: loadingRenewReasons,
                        placeholder: 'Причина возобновления',
                        items: renewReasons,
                        isClearable: true,
                        isRequired: true,
                    },
                },
                {
                    isHidden: ![5].includes(insuranceType) || !isShowRenewReasonOther,
                    field: {
                        fieldType: 'input',
                        fieldName: 'renewReasonOther',
                        placeholder: 'Укажите причину возобновления',
                        isRequired: true,
                    },
                },
            ],
        }),
        [formHook, insuranceType, isShowRenewReasonOther]
    );

    const periodForm: IForm = React.useMemo(
        () => ({
            formHook,
            fields: [
                {
                    field: {
                        fieldType: 'date',
                        fieldName: 'dateBegin',
                        placeholder: 'Начало действия',
                        errorMessage: 'Введите дату',
                        grid: 6,
                        validationType: 'minMaxDate',
                        minDate: dayjs().toDate(),
                        maxDate: dayjs().add(90, 'day').toDate(),
                        isRequired: true,
                        calendarDirection: 'up'
                    },
                },
                {
                    field: {
                        fieldType: 'input',
                        fieldName: 'dateEnd',
                        placeholder: 'Окончание действия',
                        isDisabled: true,
                        grid: 6,
                        value: dateEnd?.format('DD.MM.YYYY') || ''
                    },
                },
            ],
        }),
        [formHook, dateEnd]
    );

    return <MainLayoutIgniter>
        <StyledPrecalculationFormWrapper>
            <NewStyledPrecalculationFormCardWrapper>
                <StyledDeclarationFormCard>
                        <Heading2>Оформление</Heading2>
                    <FormProvider {...formHook}>
                    <form onSubmit={onFormSubmit}>
                        <StyledPrecalculationForm>
                            <Heading21>Заёмщик {haveCoBorrowers && <StyledShareBadge>доля в страховании {borrower?.share || '100'}%</StyledShareBadge>}</Heading21>
                            <br/><br/><br/>
                            <FieldsBuilder {...isInsurerForm}/>
                            <Contragent arrayName='contragents' number={1} disableBirthDate={riskLife} disableGender={riskLife} />
                            <br/><br/>
                            {coBorrowers.length > 0 && coBorrowers.map((item, index) => (
                                <>
                                    <Heading21>{coborrowerCaption(index)} <StyledShareBadge>доля в страховании {item?.share}%</StyledShareBadge></Heading21>
                                    <br/><br/><br/>
                                    <Contragent arrayName='coBorrowers' number={index} disableBirthDate={true} disableGender={true} />
                                    <br/><br/>
                                </>
                            ))}
                            {!isInsurer && <>
                                    <Heading21>Страхователь</Heading21>
                                    <br/><br/><br/>
                                    <Contragent arrayName='contragents' number={0} />
                                    <br/><br/>
                                </>
                            }

                            {riskProperty &&
                                <>
                                    <Heading21>{propertyName}</Heading21>
                                    <br/><br/><br/>
                                    <FieldsBuilder {...flatForm}/>
                                    <br/><br/>
                                </>}

                            <Heading21>Кредитный договор</Heading21>
                            <br/><br/><br/>
                            <FieldsBuilder {...creditForm}/>
                            <br/><br/>

                            <Heading21>Период действия договора страхования</Heading21>
                            <br/><br/><br/>
                            <FieldsBuilder {...periodForm}/>

                        </StyledPrecalculationForm>
                        <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', marginTop: '4rem'}}>
                            <Button  type='button' appearance='transparent' textFontSize='1.6rem' isLoading={stateIsLoading} onClick={backToPrecalc}>
                                Изменить расчёт
                            </Button>
                            <Button  type='submit' appearance='filled' textFontSize='1.6rem' isLoading={stateIsLoading}>
                                Создать договор
                            </Button>
                        </div>

                    </form>
                    </FormProvider>
                </StyledDeclarationFormCard>
                <StyledPrecalculationFormCard>
                    <Heading2>&nbsp;</Heading2>

                    <NewStyledBankCardsWrapper>
                        {statePrecalcResult && <ResultItem
                            isSelected={true}
                            isn={statePrecalcResult?.isn}
                            isnBank={statePrecalcResult?.isnBank}
                            name={statePrecalcResult?.name}
                            sum={statePrecalcResult?.sum}
                            premium={statePrecalcResult?.premium}
                            logo={statePrecalcResult?.logo}
                            risks={statePrecalcResult?.risks}
                            warning={statePrecalcResult?.warning}
                            needOms={false}
                            fixedDiscount={statePrecalcResult?.resultDiscount}
                            promocode={statePrecalcResult?.promocode}
                            setPromocode={()=>{}}
                            showDiscountKv={!!statePrecalcResult?.discount}
                            setDiscountKv={()=>{}}
                            discountKv={statePrecalcResult?.discount}
                            setDiscountSk={() => {}}
                            discountSk={statePrecalcResult?.discountSk}
                            isDataChanged={false}
                            inputsDisabled={true}
                            buttonsNode={undefined}
                            oldPremium={statePrecalcResult?.oldPremium}
                            discountBlockAllowed={!!statePrecalcResult?.discount || !!statePrecalcResult?.promocode || !!statePrecalcResult?.discountSk}
                        />}
                    </NewStyledBankCardsWrapper>
                </StyledPrecalculationFormCard>
            </NewStyledPrecalculationFormCardWrapper>
        </StyledPrecalculationFormWrapper>
    </MainLayoutIgniter>;
}

export default DeclarationPage;